import { TierLevels } from 'types/session/user'

export const PROGRESS_BAR_LABEL = 'accessibility.club.progress.bar'
export const DEFAULT_NET_ANUAL_EXPENSE = 0

export const TITLE_LABELS_TIERS: Record<TierLevels, string> = {
	[TierLevels.TIER_1]: 'club.home.member.title',
	[TierLevels.TIER_2]: 'club.home.classic.title',
	[TierLevels.TIER_3]: 'club.home.iconic.title',
}
